import { i18nFilter } from "app/filters/i18nFilter";
import {
    Card,
    CardTitle,
    CardText,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/HowItWorksSection/InfoCard/InfoCard.styled";

interface IInfoCardProps {
    cardIndex: number;
    title: string;
    subtitle: string;
}

const InfoCard = ({ cardIndex, title, subtitle }: IInfoCardProps) => {
    const i18n = i18nFilter();
    return (
        <Card>
            <CardTitle>{`${cardIndex}. ${i18n(title)}`}</CardTitle>
            <CardText>{i18n(subtitle)}</CardText>
        </Card>
    );
};

export default InfoCard;
